import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdAdd } from "react-icons/io";
import { BsPlayBtnFill } from "react-icons/bs";
import { AiFillHome } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import SearchBar from "../../../components/searchBar/SearchBar";
import Card from "../../../components/cards/Card";
import Table from "../../../components/tables/Table";
import Pagination from "../../../components/pagination/Pagination";
import { Link } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import ConfirmModal from "../../../components/popups/confirmationModal/ConfirmModal";
import {
  getTutotialApi,
  deleteTutorialApi,
} from "../../../services/apis/tutorials";
import showAlert from "../../../components/errorBoundries/Errors";
import Toast, { showSuccessToast } from "../../../components/toastify/Toast";

const Tutorials = () => {
  const navigate = useNavigate();
  const headers = ["Date Posted", "Title", "Youtube URL", "Text", ""];
  const keys = ["created_at", "title", "youtube_url", "description"];
  const [modalIsOpen, setIsOpen] = useState(false);
  const [tutorialsData, setTutorialsData] = useState({});
  const [tutorialId, setTutorialId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const pageSize = 10;

  const fetchData = async (data) => {
    try {
      const respones = await getTutotialApi(`?search=${data}`);
      if (respones?.status === 200) {
        setTutorialsData(respones?.data);
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    } catch (error) {
      let errors =
        error?.response?.data?.detail ||
        "Opps! Something went wrong, please try again.";
      showAlert("Error", errors, "error");
    }
  };

  useEffect(() => {
    fetchData("");
  }, []);

  const openModal = (row) => {
    setIsOpen(true);
    setTutorialId(row?.id);
    setIsConfirmDelete(false);
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsConfirmDelete(false);
  };

  useEffect(() => {
    if (isConfirmDelete === true) {
      const fetchData = async () => {
        try {
          const respones = await deleteTutorialApi(tutorialId);
          if (respones?.status === 204) {
            try {
              const respones = await getTutotialApi();
              if (respones?.status === 200) {
                setTutorialsData(respones?.data);
              } else {
                let errors = "Opps! Something went wrong, please try again.";
                showAlert("Error", errors, "error");
              }
            } catch (error) {
              let errors =
                error?.response?.data?.detail ||
                "Opps! Something went wrong, please try again.";
              showAlert("Error", errors, "error");
            }
            setIsOpen(false);
            showSuccessToast("Tutorial deleted successfully!");
          } else {
            let errors = "Opps! Something went wrong, please try again.";
            showAlert("Error", errors, "error");
          }
        } catch (error) {
          let errors =
            error?.response?.data?.detail ||
            "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      };
      fetchData();
    }
  }, [isConfirmDelete]);

  const handleEdit = (rowData) => {
    navigate(`/tutorials/edit-tutorial`, { state: { rowData } });
  };

  const extraColumnRenderer = (row) => (
    <div className="flex space-x-2">
      <FiEdit
        size={23}
        onClick={() => handleEdit(row)}
        className="cursor-pointer text-primary"
      />
      <MdDelete
        size={25}
        onClick={() => openModal(row)}
        className="cursor-pointer text-red-600"
      />
    </div>
  );
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (query) => {
    fetchData(query);
  };
  return (
    <div className="">
      <Toast />
      {/* Top Section Begin */}
      <div className="flex gap-3 items-center font-medium text-gray-500">
        <AiFillHome />
        <p>Home</p>
        <IoIosArrowForward />
        <p>Tutorials</p>
      </div>
      {/* Top Section End */}
      {/* Add Tutorial Begin */}
      <div className="flex justify-between pt-3">
        <div className="w-[30%]">
          <SearchBar
            placeholder="Search in Tutorials..."
            onSearch={handleSearch}
          />
        </div>
        <div>
          <Link to="/tutorials/add-tutorial">
            <button
              type="button"
              className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-md w-full px-3 py-2.5 text-center flex items-center gap-1"
            >
              <IoMdAdd style={{ color: "white" }} size={21} />
              Add Tutorial
            </button>
          </Link>
        </div>
      </div>
      {/* Add Tutorial End */}
      {/* Card Section Begin */}
      <div className="py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          <Card
            title={"Total Tutorials"}
            count={tutorialsData?.count}
            icon={<BsPlayBtnFill size={40} />}
          />
        </div>
      </div>
      {/* Card Section End */}
      {/* Table Begin */}
      <div className="mt-2">
        <Table
          headers={headers}
          keys={keys}
          rows={tutorialsData?.results}
          extraColumn="Actions"
          extraColumnRenderer={extraColumnRenderer}
        />
      </div>
      {/* Table End */}
      {/* Pagination Begin */}
      <div className="xl:pl-5 pl-0">
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(tutorialsData?.count / pageSize)}
          pageSize={pageSize}
          totalEntries={tutorialsData?.count}
          onPageChange={handlePageChange}
          data={tutorialsData}
          setData={setTutorialsData}
        />
      </div>
      {/* Pagination End */}
      <ConfirmModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Add FAQ Type Modal"
        onClose={closeModal}
        setIsConfirmDelete={setIsConfirmDelete}
      />
    </div>
  );
};

export default Tutorials;
